/** Mesmo visual do `<select>` nativo de `admin/ciclo-inscricao/FormularioDoCiclo.tsx`. */
export const CLASSE_DO_SELECT =
  'flex h-11 w-full rounded-xl border border-input bg-background px-3.5 text-sm focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';
